export function getURLParam(s: string): string | null {
  return new URLSearchParams(document.location.search).get(s);
}
